<div class="contact">
	<div class="contact-role">{{ role }}</div>
	@for(contact of contacts; track $index) {
	<div class="contact-content">
		<div class="contact-content-details">
			<div class="contact-content-details-name detail">
				{{ contact.name }}
			</div>
			@if(showTitle && contact.title){
			<div class="contact-content-details-title detail">
				{{ contact.title }}
			</div>
			} @if(displayEmailLink(contact)) {<a
				href="mailto:{{ contact.email }}"
				><div class="contact-content-details-email">
					{{ Loc(LocalizedTextIds.ContactSendAMessage) }}
				</div></a
			>} @if(showHubSpotLink && contact.email){
			<div
				class="contact-content-details-hub-spot"
				(click)="showHubSpotForm($index)"
			>
				{{ Loc(LocalizedTextIds.ContactSendAMessage) }}
			</div>
			}
		</div>
	</div>
	}
</div>
@if(isShowingHubSpotForm) {
<div class="contact-hub-spot-overlay">
	<div class="contact-hub-spot-overlay-content-dialog" [ngClass]="dialogCss">
		@if(!hasBeenSubmitted){
		<div class="contact-hub-spot-overlay-content-dialog-title-bar">
			<localized-text-snippet
				text="{{
					Loc(
						LocalizedTextIds.ContactGetInTouchWith,
						contactForHubspotForm.name,
						company.name
					)
				}}"
			></localized-text-snippet>
			<div
				class="contact-hub-spot-overlay-content-dialog-title-bar-close-button"
				(click)="hideHubSpotForm(false)"
			></div>
		</div>
		}
		<div class="contact-hub-spot-overlay-content-form-outer">
			<div
				class="contact-hub-spot-overlay-content-form"
				id="hubSpotForm"
			></div>
		</div>
		@if(hasBeenSubmitted) {
		<div
			class="contact-hub-spot-overlay-content-dialog-ok-button"
			(click)="hideHubSpotForm(true)"
		>
			{{ Loc(LocalizedTextIds.OK) }}
		</div>
		}
	</div>
</div>
}
